<template>
  <div>
    <v-text-field
      v-model="newValue"
      lazy-validation
      v-bind="currentProperties()"
      @input="verifyEmailExists()"
    />
  </div>
</template>

<script>
import { requests } from '@/mixins/index';

import { EventBus } from '../../mixins';

export default {
  name: 'EmailAutocomplete',
  mixins: [requests],
  props: {
    fieldName: {
      type: String,
      default: ''
    },
    field: {
      type: Object,
      default: () => {}
    },
    value: {
      type: String,
      default: ''
    }
  },
  // [
  //   'field',
  //   'value',
  //   'warnings'
  // ],
  data: function () {
    return {
      newValue: this.value,
      savedEmail: null,
      emailExists: false
    };
  },
  computed: {
    isEdit () {
      return this.$route.name === 'Customer';
    }
  },
  mounted () {
    if (this.isEdit) {
      this.savedEmail = this.newValue;
    }
  },
  methods: {
    validateEmail (email) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(email);
    },
    async verifyEmailExists () {
      this.$emit('input', this.newValue === '' ? null : this.newValue);

      if (this.newValue && this.validateEmail(this.newValue)) {
        if (this.isEdit && this.savedEmail === this.newValue) {
          return EventBus.$emit('change-warnings', { valid: true, warnings: [] });
        }

        const facet = {
          hitsPerPage: 1,
          filters: `email: ${encodeURIComponent(this.newValue)} AND workspace:${this.$store.state.brand}`
        };
        const query = '';
        const response = await this.getAutocomplete(JSON.stringify(facet), query);

        if (response.data.items && response.data.items.length) {
          this.emailExists = true;

          EventBus.$emit('email-validation:change', { isValid: false })
          return EventBus.$emit('change-warnings', { valid: false, warnings: [`<a href="/?email=${this.newValue.replace(/\+/g, '%2B')}" class="font-weight-medium">Une autre fiche contact existe déjà avec ces coordonnées, cliquez ici pour la retrouver</a>`] });
        }
        if (this.emailExists) {
          EventBus.$emit('change-warnings', { valid: true, warnings: [] });
        }
      } else if (this.emailExists) {
        EventBus.$emit('change-warnings', { valid: true, warnings: [] });
      }
      EventBus.$emit('email-validation:change', { isValid: true })
      return null;
    },
    currentProperties () {
      const properties = {};

      // General properties
      properties.rules = this.field.rules;
      properties.hint = this.field.helpText;
      properties.label = this.field.label;
      properties.disabled = this.field.disabled;
      properties.readonly = this.field.readonly;
      properties.placeholder = this.field.placeholder;
      properties.type = 'text';

      return properties;
    }
  }
};
</script>
